// consider separating out each scrolling table and each view into separate components?

import React, { Component } from 'react';
import '../styles/App.css';
import Leaderboards from '../components/Leaderboards';
import GenderAverages from '../components/GenderAverages';
import WorkoutStats from '../components/WorkoutStats';
import _ from 'lodash';

import '../styles/MainScreen.css';

let workoutSwitcher;

class MainScreen extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      workoutObj: this.props.recentWorkout.length > 0 ? this.props.recentWorkout[0] : {},
      workoutIdx: 0,
      amountOfWorkouts: this.props.recentWorkout.length
    }

    this.switchWorkouts = this.switchWorkouts.bind(this);
  }

  switchWorkouts() {

    if(this.state.workoutIdx >= this.state.amountOfWorkouts - 1) {
      return this.setState({
        workoutObj: this.props.recentWorkout[0],
        workoutIdx: 0
      })
    };
    this.setState({
      workoutObj: this.props.recentWorkout[this.state.workoutIdx + 1],
      workoutIdx: this.state.workoutIdx + 1
    });
  }

  componentDidMount() {

    workoutSwitcher = window.setInterval(() => {
      this.switchWorkouts();
    }, 10000)
  }

  componentWillReceiveProps(nextProps) {
    window.clearInterval(workoutSwitcher);

    let ourFilteredWorkouts = _.filter(nextProps.recentWorkout, (o) => {
      return o.task_type !== 'Task::Note';
    })

    this.setState({
      workoutObj: ourFilteredWorkouts.length > 0 ? ourFilteredWorkouts[0] : {},
      workoutIdx: 0,
      amountOfWorkouts: ourFilteredWorkouts.length
    }, () => {

      return workoutSwitcher = window.setInterval(() => {
        return this.switchWorkouts();
      }, 10000);
      
    });
  }

  componentWillUnmount() {
    window.clearInterval(workoutSwitcher);
  }

  render() {
    return(
      <div className="inner-wrap absolute flex pa4 w-100 h-100">
        <div className="activity relative light-blue-border w-70 ">
          <Leaderboards 
            {...this.props}
            workoutIdx={this.state.workoutIdx}
          />
        </div>
        <div className="light-blue-border no-left-border relative flex flex-wrap w-30">
          <div className="right h-70 w-100 border-bottom-light-blue">
            <WorkoutStats 
             workoutObj={this.state.workoutObj}
             workoutIdx={this.state.workoutIdx}
             amountOfWorkouts={this.state.amountOfWorkouts} />
          </div>
          <div className="averages flex w-50 h-30">
            <GenderAverages 
              workoutObj={this.state.workoutObj}
              gender="Women" />
          </div>
          <div className="averages flex w-50 h-30">
            <GenderAverages 
              workoutObj={this.state.workoutObj}
              gender="Men" />
          </div>
        </div>
      </div>
    )
  }
}

export default MainScreen;


// WEBPACK FOOTER //
// ./src/containers/MainScreen.js